type Dataset = Record<string, string>;

export const getDataAttributes = (props: any): Dataset => {
  return Object.entries(props).reduce((acc: Dataset, [key, val]) => {
    if (key.includes('data-')) {
      acc[key] = val as string;
    }
    return acc;
  }, {});
};

export const getQaDataAttributes = (
  isQaMode: boolean | undefined,
  fullNameCompType: string | undefined,
) =>
  isQaMode
    ? { 'data-comp': fullNameCompType, 'data-aid': fullNameCompType }
    : {};

export const isEmptyObject = (obj: any) =>
  !obj || (Object.keys(obj).length === 0 && obj.constructor === Object);

let lastGeneratedId: number | null = null;
let uniqueIdCounter = 0;

export function getUniqueId(prefix: string, prefixDelimiter: string) {
  prefix = prefix || '';
  prefixDelimiter = prefixDelimiter || '';
  const value = Date.now();
  if (value === lastGeneratedId) {
    uniqueIdCounter++;
  } else {
    lastGeneratedId = value;
    uniqueIdCounter = 0;
  }
  return (
    prefix +
    prefixDelimiter +
    Number(lastGeneratedId).toString(36) +
    (uniqueIdCounter ? uniqueIdCounter : '')
  );
}
